export default "__VITE_ASSET__H_aKkCul__"